<script>
import options from "./ConfiguratorTablist.options";
export default options;
</script>

<template>
    <article class="nti-configurator-tablist">
        <h2 class="nti-configurator-tablist__title">{{ verifyLabel('configuratorTitle') }}</h2>
        <div>
            <section class="nti-configurator-tablist__tab nti-configurator-tablist__tab--underline" v-if="!hasSingleLicenseType && !isHardware">
                <label class="nti-configurator-tablist__subtitle">{{ verifyLabel('levelOneLabel') }}</label>
                <div class="nti-configurator-tablist__tab-container">
                    <template v-for="data in LevelOne" :key="data.id">
                        <button 
                            class="nti-button nti-configurator-tablist__tab__link"
                            :class="{ 'nti-button--selected' : selectedLevelOne === data.id }" 
                            v-on:click="activateLevelOne(data.id)" 
                            aria-label="Select location"
                            role="tab">
                            <div v-if="selectedLevelOne === data.id" class="nti-svg__container-medium nti-svg__container-medium--checkmark">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                    <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"/>
                                </svg>
                            </div>
                            <p>{{data.displayName}}</p>
                        </button>
                    </template>
                </div>
            </section>

            <div>
                <section 
                    class="nti-configurator-tablist__tab nti-configuration-tablist__tabcontent" 
                    role="tabpanel" 
                    :class="{ 'nti-configurator-tablist__tab--underline' : selectedLevelOne }" 
                    v-if="!isHardware">
                    <label class="nti-configurator-tablist__subtitle">{{ verifyLabel('levelTwoLabel') }}</label>
                    <div class="nti-configurator-tablist__tab-container">
                        <template v-for="data in LevelTwoData" :key="data.id">
                            <button 
                                class="nti-button nti-configurator-tablist__tab__link" 
                                :class="{ 'nti-button--selected' : selectedLevelTwo === data.id }" 
                                v-on:click="chooseLevelTwo(data.id, data.name)"
                                aria-label="Select date"
                                role="tab">
                                <div v-if="selectedLevelTwo === data.id" class="nti-svg__container-medium nti-svg__container-medium--checkmark">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                        <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"/>
                                    </svg>
                                </div>
                                <p>{{data.displayName}} {{data.labelName}}</p>
                            </button>
                        </template>
                    </div>
                </section>
            </div>
            
            <div>
                <section class="nti-configurator-tablist__tab" role="tabpanel" :class="{ 'nti-configurator-tablist__tab--underline' : selectedLevelTwo || isHardware }">
                    <label for="amount-input-field" class="nti-configurator-tablist__subtitle">{{ verifyLabel('levelThreeLabel') }}</label>
                    <div class="nti-configurator-tablist__tab-container">
                        <template v-if="showNextRow">
                            <div class="plus-minus-selector nti-configurator-tablist__plus-minus">
                                <button href="#" class="plus-minus-selector__btn plus-minus-selector__btn--minus" v-on:click="decrementAmount" aria-label="Subtract product"></button>
                                    <input 
                                        id="amount-input-field" 
                                        class="nti-configurator-tablist__plus-minus__input" 
                                        name="product-amount" 
                                        v-model="amount" 
                                        @change="changeAmount"
                                        type="number">
                                <button href="#" class="plus-minus-selector__btn plus-minus-selector__btn--plus" v-on:click="incrementAmount" aria-label="Add product"></button>
                            </div>
                        </template>
                    </div>
                </section>
            </div>

            <template v-if="showNextRow">
                <section class="nti-configurator-tablist__add-to-cart">
                    <div class="nti-configurator-tablist__add-to-cart__wrapper">
                        <p class="nti-configurator-tablist__add-to-cart__price-text">{{ verifyLabel('priceLabel') }}</p>
                        <div class="nti-configurator-tablist__add-to-cart__price-container">
                            <h3 class="nti-configurator-tablist__add-to-cart__total-price" :class="{ 'nti-configurator-tablist__add-to-cart__total-price--discount' : productHasDiscount }">{{ priceText }}</h3>
                            <h3 v-if="productHasDiscount" class="nti-configurator-tablist__add-to-cart__total-price">{{ priceDiscountedText }}</h3>
                            <span class="nti-configurator-tablist__add-to-cart__label">{{ verifyLabel('exVatAndHandlingFeeLabel') }}</span>
                        </div>
                    </div>
                    <button :disabled="!allIsSelected" class="nti-button nti-button--confirm pardotTrackClick" v-on:click="addToCart">
                        <div class="nti-svg__container-medium nti-svg--add-to-cart">
                            <svg viewBox="0 0 22 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <g id="Symbols" stroke="none" stroke-width="1" fill-rule="evenodd">
                                    <g id="HEADER" transform="translate(-1314.000000, -33.000000)" fill-rule="nonzero">
                                        <g id="Shape">
                                            <path d="M1322.88889,47.6666667 C1322.88889,48.4035556 1322.29156,49 1321.55556,49 C1320.81956,49 1320.22222,48.4035556 1320.22222,47.6666667 C1320.22222,46.9306667 1320.81956,46.3333333 1321.55556,46.3333333 C1322.29156,46.3333333 1322.88889,46.9306667 1322.88889,47.6666667 Z M1326,46.3333333 C1325.264,46.3333333 1324.66667,46.9297778 1324.66667,47.6666667 C1324.66667,48.4035556 1325.264,49 1326,49 C1326.736,49 1327.33333,48.4035556 1327.33333,47.6666667 C1327.33333,46.9306667 1326.736,46.3333333 1326,46.3333333 Z M1316.61067,41.8888889 L1314,35.6666667 L1328.944,35.6666667 L1327.18667,41.8888889 L1316.61067,41.8888889 Z M1326.59556,37.4444444 L1316.67378,37.4444444 L1317.79289,40.1111111 L1325.84267,40.1111111 L1326.59556,37.4444444 Z M1331.60444,33 L1328.55378,43.6666667 L1317.35644,43.6666667 L1318.10222,45.4444444 L1329.87022,45.4444444 L1332.95822,34.7777778 L1334.67289,34.7777778 L1335.33333,33 L1331.60444,33 Z"></path>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                        </div>
                        {{ verifyLabel('addToBasket') }}
                    </button>
                </section>
            </template>
        </div>
        
    </article>
</template>